import { takeEvery, takeLatest } from 'redux-saga/effects';
import {
  ADD_EXCEL_ACTIVITY_NOTE_REQUEST,
  ADD_ORGANISATION_REQUEST,
  BULK_UPDATE_EXCEL_TRANSACTIONS_REQUEST,
  CONNECT_CIN7_ENTITY_REQUEST,
  CREATE_EXCEL_CONTACT_REQUEST,
  DELETE_EXCEL_CONTACT_REQUEST,
  CREATE_ENTITY_GROUP_REQUEST,
  DELETE_ENTITY_GROUP_REQUEST,
  UPDATE_ENTITY_GROUP_REQUEST,
  DELETE_EXCEL_TRANSACTION_REQUEST,
  DELETE_EXCEL_TRANSACTIONS_FILE_REQUEST,
  DELETE_ORGANISATION_ATTACHMENT_REQUEST,
  DISCONNECT_ORGANISATION_REQUEST,
  DOWNLOAD_ORGANISATION_ATTACHMENT_REQUEST,
  EDIT_ORGANISATION_REQUEST,
  FETCH_ACCOUNTS_REQUEST,
  FETCH_ADD_URL_REQUEST,
  FETCH_ORGANISATION_CONTACTS_REQUEST,
  FETCH_ALL_EXCEL_TRANSACTIONS_REQUEST,
  FETCH_EXCEL_ACTIVITY_LOGS_REQUEST,
  FETCH_TRACKING_CATEGORIES_REQUEST,
  FETCH_TRANSACTION_ITEMS_REQUEST,
  FETCH_EXCEL_FILES_METADATA_REQUEST,
  FETCH_LAST_RECEIPT_UPLOAD_STATUS_REQUEST,
  FETCH_ORGANISATIONS_LIGHT_REQUEST,
  FETCH_ORGANISATIONS_REQUEST,
  FETCH_UPLOADED_FILE_TRANSACTIONS_REQUEST,
  GET_DRIVE_SCANNER_STATUS,
  GET_FILES_UPLOAD_HISTORY,
  REACTIVATE_ORGANISATION_REQUEST,
  REGISTER_DRIVE_FOLDER,
  SAVE_GOOGLE_TOKEN,
  SET_TRANSACTIONS_REVIEWED_REQUEST,
  UPDATE_EXCEL_CONTACT_REQUEST,
  UPDATE_EXCEL_TRANSACTION_REQUEST,
  ADD_EXCEL_TRANSACTIONS_REQUEST,
  UPLOAD_EXCEL_TRANSACTIONS_REQUEST,
  UPLOAD_ORGANISATION_ATTACHMENT_REQUEST,
  UPLOAD_RECEIPT_REQUEST,
  UPLOAD_RECEIPT_TO_PROVIDER_REQUEST,
  DISCONNECT_FOLDER,
  RESCAN_FILE,
  SAVE_EXCEL_DRAWER_TRANSACTIONS_BATCH_REQUEST,
  GENERATE_SCAN_EMAIL,
  GET_SCAN_EMAIL_STATUS,
  COMPLETE_SCAN_STEPS_REQUEST,
  HMRC_FRAUD_HEADER_TEST_REQUEST,
  FETCH_RECEIPT_STATISTICS_ALL_REQUEST,
  FETCH_RECEIPT_STATISTICS_ENTITY_REQUEST,
} from '../constants';
import { addExcelActivityNoteSaga } from './addExcelActivityNoteSaga';
import { addOrganisationSaga } from './addOrganisationSaga';
import { bulkUpdateExcelTransactionsSaga } from './bulkUpdateExcelTransactionsSaga';
import { connectCin7EntitySaga } from './connectCin7EntitySaga';
import { createEntityGroupSaga } from './createEntityGroupSaga';
import { deleteEntityGroupSaga } from './deleteEntityGroupSaga';
import { updateEntityGroupSaga } from './updateEntityGroupSaga';
import { deleteExcelTransactionSaga } from './deleteExcelTransactionSaga';
import { deleteExcelTransactionsFileSaga } from './deleteExcelTransactionsFileSaga';
import { deleteOrganisationAttachmentSaga } from './deleteOrganisationAttachmentSaga';
import { disconnectOrganisationSaga } from './disconnectOrganisationSaga';
import { downloadOrganisationAttachmentSaga } from './downloadOrganisationAttachmentSaga';
import { editOrganisationsSaga } from './editOrganisationsSaga';
import { fetchAccountsSaga } from './fetchAccountsSaga';
import { fetchOrganisationContactsSaga } from './fetchOrganisationContactsSaga';
import { createExcelContactSaga } from './createExcelContactSaga';
import { deleteExcelContactSaga } from './deleteExcelContactSaga';
import { updateExcelContactSaga } from './updateExcelContactSaga';
import { fetchAddUrlSaga } from './fetchAddUrlSaga';
import { fetchAllExcelTransactionsSaga } from './fetchAllExcelTransactionsSaga';
import { fetchExcelActivityLogsSaga } from './fetchExcelActivityLogsSaga';
import { fetchTrackingCategoriesSaga } from './fetchTrackingCategoriesSaga';
import { fetchTransactionItemsSaga } from './fetchTransactionItemsSaga';
import { fetchExcelFilesMetadataSaga } from './fetchExcelFilesMetadataSaga';
import { fetchLastReceiptUploadStatusSaga } from './fetchLastReceiptUploadStatusSaga';
import {
  fetchOrganisationsLightSaga,
  fetchOrganisationsSaga,
} from './fetchOrganisationsSaga';
import { fetchUploadedFileTransactionsSaga } from './fetchUploadedFileTransactionsSaga';
import { reactivateOrganisationSaga } from './reactivateOrganisationSaga';
import {
  disconnectFolderSaga,
  getDriveScannerStatusSaga,
  getFilesUploadHistorySaga,
  registerDriveFolderSaga,
  saveGoogleTokenSaga,
} from './driveScannerSaga';
import { setTransactionsReviewedSaga } from './setTransactionsReviewedSaga';
import { updateExcelTransactionSaga } from './updateExcelTransactionSaga';
import { addExcelTransactionsSaga } from './addExcelTransactionsSaga';
import { saveExcelDrawerTransactionsBatchSaga } from './saveExcelDrawerTransactionsBatchSaga';
import { uploadExcelTransactionsSaga } from './uploadExcelTransactionsSaga';
import { uploadOrganisationAttachmentSaga } from './uploadOrganisationAttachmentSaga';
import { uploadReceiptSaga } from './uploadReceiptSaga';
import { uploadReceiptToProviderSaga } from './uploadReceiptToProviderSaga';
import { rescanReceiptSaga } from './rescanReceiptSaga';
import {
  generateScanEmailSaga,
  getScanEmailStatusSaga,
} from './generateScanEmailSaga';
import { completeScanStepsSaga } from './completeScanStepsSaga';
import { hmrcFraudHeaderTestSaga } from './hmrcFraudHeaderTestSaga';
import { fetchReceiptStatisticsAllSaga } from './fetchReceiptStatisticsAllSaga';
import { fetchReceiptStatisticsEntitySaga } from './fetchReceiptStatisticsEntitySaga';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* organisationSaga() {
  yield takeLatest(FETCH_ORGANISATIONS_REQUEST, fetchOrganisationsSaga);
  yield takeLatest(
    FETCH_ORGANISATIONS_LIGHT_REQUEST,
    fetchOrganisationsLightSaga
  );
  yield takeLatest(FETCH_ADD_URL_REQUEST, fetchAddUrlSaga);
  yield takeLatest(CONNECT_CIN7_ENTITY_REQUEST, connectCin7EntitySaga);
  yield takeLatest(DISCONNECT_ORGANISATION_REQUEST, disconnectOrganisationSaga);
  yield takeLatest(REACTIVATE_ORGANISATION_REQUEST, reactivateOrganisationSaga);
  yield takeLatest(EDIT_ORGANISATION_REQUEST, editOrganisationsSaga);
  yield takeLatest(FETCH_ACCOUNTS_REQUEST, fetchAccountsSaga);
  yield takeLatest(
    FETCH_ORGANISATION_CONTACTS_REQUEST,
    fetchOrganisationContactsSaga
  );
  yield takeLatest(CREATE_EXCEL_CONTACT_REQUEST, createExcelContactSaga);
  yield takeLatest(UPDATE_EXCEL_CONTACT_REQUEST, updateExcelContactSaga);
  yield takeLatest(DELETE_EXCEL_CONTACT_REQUEST, deleteExcelContactSaga);
  yield takeLatest(
    UPLOAD_ORGANISATION_ATTACHMENT_REQUEST,
    uploadOrganisationAttachmentSaga
  );
  yield takeLatest(
    DELETE_ORGANISATION_ATTACHMENT_REQUEST,
    deleteOrganisationAttachmentSaga
  );
  yield takeLatest(
    DOWNLOAD_ORGANISATION_ATTACHMENT_REQUEST,
    downloadOrganisationAttachmentSaga
  );
  yield takeLatest(ADD_ORGANISATION_REQUEST, addOrganisationSaga);
  yield takeLatest(CREATE_ENTITY_GROUP_REQUEST, createEntityGroupSaga);
  yield takeLatest(DELETE_ENTITY_GROUP_REQUEST, deleteEntityGroupSaga);
  yield takeLatest(UPDATE_ENTITY_GROUP_REQUEST, updateEntityGroupSaga);
  yield takeLatest(
    UPLOAD_EXCEL_TRANSACTIONS_REQUEST,
    uploadExcelTransactionsSaga
  );
  yield takeLatest(
    FETCH_UPLOADED_FILE_TRANSACTIONS_REQUEST,
    fetchUploadedFileTransactionsSaga
  );
  yield takeLatest(
    FETCH_ALL_EXCEL_TRANSACTIONS_REQUEST,
    fetchAllExcelTransactionsSaga
  );
  yield takeLatest(
    FETCH_EXCEL_FILES_METADATA_REQUEST,
    fetchExcelFilesMetadataSaga
  );
  yield takeLatest(
    DELETE_EXCEL_TRANSACTIONS_FILE_REQUEST,
    deleteExcelTransactionsFileSaga
  );
  yield takeLatest(
    DELETE_EXCEL_TRANSACTION_REQUEST,
    deleteExcelTransactionSaga
  );
  yield takeLatest(
    SAVE_EXCEL_DRAWER_TRANSACTIONS_BATCH_REQUEST,
    saveExcelDrawerTransactionsBatchSaga
  );
  yield takeLatest(
    UPDATE_EXCEL_TRANSACTION_REQUEST,
    updateExcelTransactionSaga
  );
  yield takeLatest(
    ADD_EXCEL_TRANSACTIONS_REQUEST,
    addExcelTransactionsSaga
  );
  yield takeLatest(UPLOAD_RECEIPT_REQUEST, uploadReceiptSaga);
  yield takeLatest(
    FETCH_LAST_RECEIPT_UPLOAD_STATUS_REQUEST,
    fetchLastReceiptUploadStatusSaga
  );
  yield takeLatest(
    SET_TRANSACTIONS_REVIEWED_REQUEST,
    setTransactionsReviewedSaga
  );
  yield takeLatest(
    BULK_UPDATE_EXCEL_TRANSACTIONS_REQUEST,
    bulkUpdateExcelTransactionsSaga
  );
  yield takeLatest(
    FETCH_EXCEL_ACTIVITY_LOGS_REQUEST,
    fetchExcelActivityLogsSaga
  );
  yield takeEvery(
    FETCH_TRACKING_CATEGORIES_REQUEST,
    fetchTrackingCategoriesSaga
  );
  yield takeLatest(
    FETCH_TRANSACTION_ITEMS_REQUEST,
    fetchTransactionItemsSaga
  );
  yield takeLatest(ADD_EXCEL_ACTIVITY_NOTE_REQUEST, addExcelActivityNoteSaga);
  yield takeLatest(REGISTER_DRIVE_FOLDER, registerDriveFolderSaga);
  yield takeLatest(SAVE_GOOGLE_TOKEN, saveGoogleTokenSaga);
  yield takeLatest(GET_DRIVE_SCANNER_STATUS, getDriveScannerStatusSaga);
  yield takeLatest(GET_FILES_UPLOAD_HISTORY, getFilesUploadHistorySaga);
  yield takeLatest(
    UPLOAD_RECEIPT_TO_PROVIDER_REQUEST,
    uploadReceiptToProviderSaga
  );
  yield takeLatest(DISCONNECT_FOLDER, disconnectFolderSaga);
  yield takeLatest(RESCAN_FILE, rescanReceiptSaga);
  yield takeLatest(GENERATE_SCAN_EMAIL, generateScanEmailSaga);
  yield takeLatest(GET_SCAN_EMAIL_STATUS, getScanEmailStatusSaga);
  yield takeLatest(COMPLETE_SCAN_STEPS_REQUEST, completeScanStepsSaga);
  yield takeLatest(HMRC_FRAUD_HEADER_TEST_REQUEST, hmrcFraudHeaderTestSaga);
  yield takeLatest(
    FETCH_RECEIPT_STATISTICS_ALL_REQUEST,
    fetchReceiptStatisticsAllSaga
  );
  yield takeLatest(
    FETCH_RECEIPT_STATISTICS_ENTITY_REQUEST,
    fetchReceiptStatisticsEntitySaga
  );
}
